"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _redux = require("redux");
var _reactRedux = require("react-redux");
var _categories = require("@mulesoft/exchange-ui-portals-store/lib/domains/categories");
var _assets = require("@mulesoft/exchange-ui-portals-store/lib/domains/assets");
var _exchangeReactHooks = require("@mulesoft/exchange-react-hooks");
var _EditableCategories = _interopRequireDefault(require("./EditableCategories"));
var getMasterOrganizationId = function getMasterOrganizationId(organization) {
  if (organization.isMaster) {
    return organization.id;
  }
  if (organization.parentOrganizationIds && organization.parentOrganizationIds[0]) {
    return organization.parentOrganizationIds[0];
  }

  // fallback for when everything above fails
  return organization.id;
};
var mapStateToProps = function mapStateToProps(state, _ref) {
  var asset = _ref.asset;
  return {
    asset: asset,
    organizationCategories: _categories.selectors.categories(state, {
      organizationId: getMasterOrganizationId(asset.organization)
    }) || []
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onUpdateAssetCategory: function onUpdateAssetCategory(payload) {
      return dispatch(_assets.actions.updateAssetCategory(payload));
    },
    onRemoveAssetCategory: function onRemoveAssetCategory(payload) {
      return dispatch(_assets.actions.removeAssetCategory(payload));
    }
  };
};
var _default = exports.default = (0, _redux.compose)(_exchangeReactHooks.withRouter, (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps))(_EditableCategories.default);
//# sourceMappingURL=EditableCategories.container.js.map